import { useCallback, useEffect, useLayoutEffect, useState } from 'react';

export const useWindow = (containerRef?: React.RefObject<HTMLDivElement>) => {
  const [windowSize, setWindowSize] = useState({
    innerWidth: typeof window !== 'undefined' ? window.innerWidth : 0,
    innerHeight: typeof window !== 'undefined' ? window.innerHeight : 0,
  });

  const [containerWidth, setContainerWidth] = useState(0);
  const [containerHeight, setContainerHeight] = useState(0);
  const [isOverflowX, setIsOverflowX] = useState(false);
  const [isOverflowY, setIsOverflowY] = useState(false);

  const updateContainerSize = useCallback(() => {
    if (containerRef?.current) {
      const el = containerRef?.current;
      const overflowX = el.scrollWidth > el.clientWidth;
      const overflowY = el.scrollHeight > el.clientHeight;

      setContainerWidth(el.clientWidth);
      setContainerHeight(el.clientHeight);
      setIsOverflowX(overflowX);
      setIsOverflowY(overflowY);
    }
  }, [containerRef]);

  useEffect(() => {
    const observer = new ResizeObserver(() => {
      setWindowSize({
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight,
      });
    });
    observer.observe(document.documentElement);

    return () => {
      observer.disconnect();
    };
  }, []);

  useLayoutEffect(() => {
    updateContainerSize();
  }, [containerRef, updateContainerSize, windowSize]);

  return {
    windowSize,
    containerWidth,
    containerHeight,
    isOverflowX,
    isOverflowY,
  };
};
